<template>
    <div>
        <v-row>
            <v-col v-for="i in 3" :key="i">
                <div class="bg-grey-lighten-4  pa-2 text-center text-darkblue  rounded"
                    :class="{ 'bg-darkblue text-white': i == campaignStore.current_step }">
                    <span v-if="i == 1">Configuration de la campagne</span>
                    <span v-if="i == 2">Contenu de l'email</span>
                    <span v-if="i == 3">Vérification et envoi</span>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { useCampaignStore } from "@/stores/mailingSystem/campaignStore";
import { mapStores } from "pinia";
export default {
    computed: {
        ...mapStores(useCampaignStore),
    },

}
</script>

<style lang="scss" scoped></style>